import { extractIdFromPathSegment } from "../../../utils";
import type { CaseInfoFormValues, CreationMethod } from "./schema";

export const extractLookupId = (
  creationMethod: CreationMethod,
  values: Pick<CaseInfoFormValues, "positionId" | "prospectIdOrSubscriptionUrl">,
): string => {
  switch (creationMethod) {
    case "position":
      return extractIdFromPathSegment(values.positionId, "position")?.toString() ?? "";
    case "prospect":
      return (
        extractIdFromPathSegment(values.prospectIdOrSubscriptionUrl, "prospect")?.toString() ??
        ""
      );
    default:
      return "";
  }
};

export const isLookupOutOfSync = (
  creationMethod: CreationMethod,
  values: Pick<CaseInfoFormValues, "positionId" | "prospectIdOrSubscriptionUrl">,
  lookedUpLookupId: string,
): boolean => {
  const isLookupMode = creationMethod === "prospect" || creationMethod === "position";
  return (
    isLookupMode &&
    lookedUpLookupId !== "" &&
    extractLookupId(creationMethod, values) !== lookedUpLookupId
  );
};
